import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Avatar, LetterAvatar, Text, Icon, NewButton } from '../../../../../components';

const ParticipantListItemContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  column-gap: 8px;
  height: 40px;
  box-sizing: border-box;
`;

const DeleteButton = styled(NewButton)`
  cursor: pointer;
  margin-left: auto;
`;

const ParticipantListItem = ({ item, onDelete, currentUserId }) => (
  <ParticipantListItemContainer>
    {item?.picture ? (
      <Avatar width={24} height={24} src={item?.picture} />
    ) : (
      <LetterAvatar size={24} name={item?.email} />
    )}
    <Text $color='var(--black)'>{item?.name}</Text>
    {item?.id !== currentUserId && (
      <DeleteButton tertiary onClick={() => onDelete(item?.id)}>
        <Icon name='trash' size={20} />
      </DeleteButton>
    )}
  </ParticipantListItemContainer>
);

ParticipantListItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    picture: PropTypes.string,
    email: PropTypes.string
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  currentUserId: PropTypes.string.isRequired
};

export { ParticipantListItem };
